// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_6fcb30f8","itemId":"_49426674"};